import React from 'react';
import {
    Typography,
} from '@mui/material';
import { BrandContext } from '../../App';
import { useAPI } from "/src/hooks/useAPI";


export default function DashboardMarketing() {
    const { brand, user, authToken } = React.useContext(BrandContext);
    const [settings, setSettings] = React.useState(null);
    const {callAPI} = useAPI();

    function updateSettings() {
        callAPI(`settings`, {
            token: authToken
        }).then((data) => {
                setSettings(data);
                console.log(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    React.useEffect(() => {
        document.title = `Settings - ${brand.name}`;
    }, [user]);

    React.useEffect(() => {
        updateSettings();

    },[authToken]);

    return (
        <React.Fragment>
            <Typography variant="h4">Settings</Typography>
        </React.Fragment>
    );
}